var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4962_643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.32941 23.9972C4.92212 23.9972 4.58823 23.6725 4.58823 23.2772V2.7C4.58823 1.212 5.83694 0 7.36941 0H16.6306C18.1624 0 19.4118 1.212 19.4118 2.7V23.2765C19.4118 23.5292 19.2755 23.7692 19.0412 23.9012C18.9283 23.9661 18.8004 24.0002 18.6702 24.0002C18.54 24.0002 18.4121 23.9661 18.2993 23.9012L11.9936 20.4332L5.68941 23.9012C5.59059 23.9612 5.45435 23.9972 5.33082 23.9972H5.32941Z",
    fill: "#C6CBD9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4962_643"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/save-icon.5fe14dc89392ca5cafd3ae15ac313759.svg";
export { ForwardRef as ReactComponent };